import io from 'socket.io-client';
import { baseUrl, baseUrlLocal } from './config';     // importamos la URL base
import { getToken } from '../../helpers/helpers';

// Variable global para almacenar la instancia del socket (patrón Singleton)
let socketInstance = null;

/**
 * Inicializa o retorna la instancia existente del socket (spec 003-optimized-ot-list)
 * Patrón Singleton para evitar múltiples conexiones Socket.io
 * @returns {Socket} Instancia de Socket.io
 */
const initWebsockets = () => {
    // Si ya existe una instancia, retornarla directamente
    if (socketInstance && socketInstance.connected) {
        console.log('✅ Reutilizando conexión Socket.io existente');
        return socketInstance;
    }
    
    // Si existe pero está desconectada, limpiar
    if (socketInstance && !socketInstance.connected) {
        console.log('⚠️ Socket desconectado, creando nueva conexión...');
        socketInstance.disconnect();
        socketInstance = null;
    }
    
    // Crear nueva instancia
    const urlConnect = process.env.NODE_ENV === 'development' 
        ? baseUrlLocal.split("/api")[0] 
        : baseUrl.split("/api")[0];
    
    const tokenActual = getToken();
    console.log('🔗 Creando nueva conexión Socket.io:', urlConnect, 'token?', Boolean(tokenActual));
    socketInstance = io(urlConnect, {
        transports: ['websocket'],
        auth: { token: tokenActual }
    });

    // 'connect' (no 'connection') es el evento del cliente socket.io.
    socketInstance.on('connect', () => {
        console.log('✅ Conectado al servidor Socket.io id=', socketInstance.id);
    });

    socketInstance.on('connect_error', (err) => {
        // UNAUTHORIZED = token inválido o ausente al handshake.
        console.warn('⚠️ Socket.io connect_error:', err?.message);
    });

    socketInstance.on('disconnect', (reason) => {
        console.log('⚠️ Desconectado del servidor Socket.io, razón:', reason);
    });

    return socketInstance;
}

/**
 * Obtiene la instancia actual del socket sin crear una nueva
 * @returns {Socket|null} Instancia actual o null si no existe
 */
const getSocket = () => {
    return socketInstance;
}

/**
 * Cierra la conexión del socket (para cleanup manual)
 */
const closeSocket = () => {
    if (socketInstance) {
        socketInstance.disconnect();
        socketInstance = null;
        console.log('🔴 Socket.io desconectado manualmente');
    }
}

export { initWebsockets, getSocket, closeSocket };